<template>
  <div class="address">
    <Header :title="id>0?'修改地址':'新增地址' " :show="true" />
    <LoadingModal />
    <van-form @submit="onSave" label-width="60">
      <h5>
        填写信息
        <span @click="selectWechat" v-if="id<=0">使用微信收货地址</span>
      </h5>
      <div class="main">
        <van-field v-model="cnee" name="联系人" label="联系人" placeholder="名字" ref="cnee" />
        <van-field
          v-model="phone"
          type="number"
          maxlength="11"
          name="手机号码"
          label="手机号码"
          placeholder="11位手机号"
          ref="phone"
        />
        <van-field
          readonly
          clickable
          name="area"
          :value="area"
          label="选择地区"
          placeholder="地区信息"
          @click="showArea = true"
          ref="area"
          is-link
        />
        <van-popup v-model="showArea" position="bottom">
          <van-area :area-list="areaList" @confirm="onConfirm" @cancel="showArea = false" />
        </van-popup>
        <van-field
          v-model="detail"
          rows="1"
          autosize
          label="详细地址"
          type="textarea"
          placeholder="街道门牌信息"
          ref="detail"
        />
      </div>
      <div style="margin-top:15px;">
        <van-button
          block
          type="info"
          color="var(--depYelColor)"
          native-type="submit"
        >{{id>0?'保存':'提交'}}</van-button>
      </div>
      <div style="margin-top:15px;" v-if="id>0">
        <van-button native-type="button" block type="default" @click="onDelete">删除</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import { getAddressInfo } from "api/user";
import { addAddress, delAddress } from "api/submit";
import area from "server/data/address";
import { wechatAuth } from "api/wechatSDK";
/* global wx */
export default {
  data() {
    return {
      showArea: false,
      areaList: {},
      id: 0,
      cnee: "",
      phone: "",
      area: "",
      detail: "",
      isDefault: "",
    };
  },
  created() {
    wechatAuth(["openAddress"]);
    this.areaList = area;
  },
  mounted() {
    let id = Number(this.$route.query.id);
    if (id > 0) {
      this.id = id;
      this.getAddressInfo();
    } else {
      this.$store.commit("setPageLoading", false);
    }
  },
  methods: {
    onConfirm(values) {
      this.area = values.map((item) => item.name).join("");
      this.showArea = false;
    },
    getAddressInfo() {
      getAddressInfo(this.id).then((res) => {
        if (res.status == 1) {
          this.cnee = res.data.name;
          this.phone = res.data.tel;
          this.area = res.data.area;
          this.detail = res.data.detail;
          this.isDefault = res.data.isDefault;
        } else {
          this.$error(res.message);
        }
        this.$nextTick(() => {
          this.$store.commit("setPageLoading", false);
        });
      });
    },
    selectWechat() {
      let that = this;
      wx.openAddress({
        success: function (res) {
          var userName = res.userName; // 收货人姓名
          var provinceName = res.provinceName; // 国标收货地址第一级地址（省）
          var cityName = res.cityName; // 国标收货地址第二级地址（市）
          var county = res.countryName; //国标收货地址第三级地址（区县）
          var detailInfo = res.detailInfo; // 详细收货地址信息
          var telNumber = res.telNumber; // 收货人手机号码
          that.cnee = userName;
          that.phone = telNumber;
          that.area = provinceName + "/" + cityName + "/" + county;
          that.detail = detailInfo;
        },
      });
    },
    onSave() {
      if (this.cnee == "") {
        this.$error("请输入收件人姓名", 1);
        this.$refs.cnee.focus();
        return;
      }
      if (this.phone == "") {
        this.$error("请输入收件人联系电话", 1);
        this.$refs.phone.focus();
        return;
      }
      if (this.area == "") {
        this.$error("请选择地区", 1);
        this.$refs.area.focus();
        return;
      }
      if (this.detail == "") {
        this.$error("请输入详细地址", 1);
        this.$refs.detail.focus();
        return;
      }
      if (!this.$regSymbol(this.cnee)) {
        this.$error("收件人仅支持中文", 1);
        return;
      }
      if (!this.$regPhone(this.phone)) {
        this.$error("手机号码格式不正确", 1);
        return;
      }
      this.$loading("处理中");
      if (this.id <= 0) {
        addAddress(
          "",
          this.cnee,
          this.phone,
          this.area.replace(/[/]/g, ""),
          this.detail
        ).then((res) => {
          this.$clear();
          if (res.status == 1) {
            this.$successSync("添加成功", () => {
              if (this.$route.query.isexam != undefined) {
                var arry = {};
                arry.cnee = this.cnee;
                arry.phone = this.phone;
                arry.address = this.area.replace(/[/]/g, "") + this.detail;
                this.$setItem("addressInfo", arry);
                // location.href="/examination";
                this.$push({
                  path: "/examination",
                });
              } else if (this.$route.query.toPage != undefined) {
                this.$push({
                  path: "/address",
                  query: { toPage: this.$route.query.toPage},
                });
              } else {
                this.$push({
                  path: "/address",
                });
              }
            });
          } else {
            this.$error(res.message);
          }
        });
      } else {
        addAddress(this.id, this.cnee, this.phone, this.area, this.detail).then(
          (res) => {
            this.$clear();
            if (res.status == 1) {
              this.$successSync("修改成功", () => {
                this.$push({
                  path: "/address",
                });
              });
            } else {
              this.$error(res.message);
            }
          }
        );
      }
    },
    onDelete() {
      if (this.id > 0) {
        this.$confirm("确定要删除吗，删除后不可恢复").then(() => {
          delAddress(this.id, this.isDefault).then((res) => {
            if (res.status == 1) {
              this.$successSync("删除成功", () => {
                this.$push({
                  path: "/address",
                });
              });
            } else {
              this.$error(res.message);
            }
          });
        });
      }
    },
  },
};
</script>

<style scoped lang="less">
.van-form {
  margin: 15px;
}
.main {
  border-radius: 5px;
  padding: 3px;
  box-shadow: #ccc 0 0 10px;
  background: #fff;
}
h5 {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  span {
    text-decoration-line: underline;
    font-weight: initial;
    color: #09bb07;
  }
}
</style>
